import { getData, putData } from 'helpers/apiHelper';
import { MAIN_PATH, EMAIL_PREFERENCES_LIST, EMAIL_PREFERENCES_UPDATE } from './apiPath';

//get
export function getEmailPreferenceList(token) {
  const query = token ? `?token=${token}` : "";
  return getData(`${MAIN_PATH}${EMAIL_PREFERENCES_LIST}${query}`)
}

//add
export function saveEmailPreference(token, id, payload) {
  const query = token ? `?token=${token}` : "";
  return putData(`${MAIN_PATH}${EMAIL_PREFERENCES_UPDATE}/${id}${query}`, payload)
}
